<template>
  <div style="width: 100%;height: 100%;overflow: hidden;">
    <div id="title" class="header">
      <div id="bimname">
        <div style="width: 25px;background-color:#007a37;height: 100px;"></div>
        <img class="image" src="../assets/Hs.png" />
        <div style="width: 25px;background-color: #007a37;height: 100px;"></div>
        <p id="name">中国华西企业股份有限公司智能建造技术中心</p>
      </div>
      <div id="baseinfo">
      </div>
    </div>
    <div class="app-main">
      <div id="navdiv">
        <el-col :span="24">
          <el-menu default-active="/home" class="el-menu-vertical-demo"   router="true">
            <el-menu-item index="/home">
              <i class="el-icon-menu"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>Ai</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/staff" class="el-menu-item-two" style="padding-left: 40px;padding-right: 0px;width: 110px;">
                  <i class="el-icon-document"></i>
                  <span slot="title">问答</span>
                </el-menu-item>
                <el-menu-item index="/staff" class="el-menu-item-two">
                  <i class="el-icon-document"></i>
                  <span slot="title">PPT</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/Work" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">工作计划</span>
                </el-menu-item>
                <el-menu-item index="/home" class="el-menu-item-two">
                  <i class="el-icon-setting" ></i>
                  <span slot="title">进度计划</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>应用</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/lighttest" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">轻量化展示</span>
                </el-menu-item>
                <el-menu-item index="/Bi" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">BI大屏</span>
                </el-menu-item>
                <el-menu-item index="/ProcessModel" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">模型进度</span>
                </el-menu-item>
                <el-menu-item index="/test" class="el-menu-item-two"> 
                  <i class="el-icon-setting"></i>
                  <span slot="title">集成测试</span>
                </el-menu-item>
                <el-menu-item index="/GangJin" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">钢筋管理</span>
                </el-menu-item>
                <el-menu-item index="/BiModel/BiMain" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">数字大屏</span>
                </el-menu-item>
                <el-menu-item index="/LiZiQiang" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">李自强</span>
                </el-menu-item>
                <el-menu-item index="/Bi/index" class="el-menu-item-two">
                  <i class="el-icon-setting"></i>
                  <span slot="title">Bi测试</span>
                </el-menu-item>
              </el-menu-item-group>
              
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>资源</span>
              </template>
              <el-menu-item-group>             
                <el-menu-item index="/staff" class="el-menu-item-two">
                  <i class="el-icon-document"></i>
                  <span slot="title">学习</span>
                </el-menu-item>
                <el-menu-item index="/ZiYuan/RuanJian" class="el-menu-item-two">
                  <i class="el-icon-document"></i>
                  <span slot="title">软件</span>
                </el-menu-item>
                <el-menu-item index="/staff" class="el-menu-item-two">
                  <i class="el-icon-document"></i>
                  <span slot="title">数据</span>
                </el-menu-item>
                <el-menu-item index="/staff" class="el-menu-item-two">
                  <i class="el-icon-document"></i>
                  <span slot="title">云资源</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

          </el-menu>

        </el-col>
        <div id="companyinfo">
          <img src="../image/MainWindow/connect.png" />
          <p>关注公众号</p>
        </div>
      </div>
      <div class="app-main-content" style="margin: 5px;">
        <router-view />
      </div>
    </div>

    <div id="foot">
      <p> </p>
            <p></p>
    </div>

  </div>
</template>
<style scoped>
.HomeView{
  height: 100%;
  width: 100%;
  overflow-y: hidden;
}
html {
  height: 100%;
  overflow: hidden;
}
.body {
  height: 100%;
  overflow: hidden;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* 这是Bim中心管理平台的样式 */
#bimname {
  color: white;
  position: fixed;
  height: 100px;
  text-align: left;
  justify-content: left;
  display: flex;
}
#title {
  width: 100%;
  height: 100px;
  background: #007a37;
}
.image {
  height: 100px;
  width: 100px;
}
#name {
  margin-left: 30px;
  font-size: 30px;
  margin-top: 0px;
  float: left;
}
/*--------------------------------*/
.app-main {
  flex: 1;
  display: flex;

  
}
.app-main .app-main-content {
  position: absolute;
  width: 94%;
  top: 100px;
  bottom: 120px;
  left: 150px;
  flex: 1;
  overflow-y: hidden;
  overflow:hidden;

}
/*-----------查询内容和分享按钮------*/
#baseinfo {
  width: 240px;
  height: 95px;
  position: absolute;
  right: 0;
  text-align: left;
}
#searchdiv {
  margin-top: 10px;
  height: 40px;
  width: 220px;
}
#search {
  width: 180px;
  height: 30px;
  background: white;
  border: 0px;
}

#searchbutton {
  width: 40px;
  height: 30px;
  left: 100;
}
/*--------------------------------*/
#settingdiv {
 
  height: 45px;
}

#message {
  height: 20px;
  width: 100px;
  top: -20px;
}
#user {
  background-color: #6699cc;
  cursor: pointer;
  margin-left: 80px;
}
/*--------------------------------*/
/*--------------------------------*/
#navdiv {
  height: 100%;
  width: 150px;
  background: #f7f7f7;
  position: fixed;
  left: 0;

}
#navdiv span {
  font-size: 16px;
}
#companyinfo {
  height: 95px;
  width: 150px;
  position: fixed;
  z-index: 4;
  bottom: 100px;
  text-align: center;
  font-size: 13px;
}
/*--------------------------------*/
/*--------------------------------*/
#foot {
  height: 100px;
  width: 100%;
  background: #333333;
  text-align: center;
  color: white;
  font-size: 14px;
  position: fixed;
  bottom: 0;
}
#foot p {
  margin-top: 20px;
}

.el-submenu__title{
  background-color: rgb(227, 236, 237);
  text-align: left;
  width: 150px;
}
.el-menu-item{
  text-align: left;
  width: 150px;
  padding-left: -40px;
}
.el-menu-vertical-demo{
  width: 150px;
  min-height: 400px;
}</style>
<script>
export default {
  name: "App",
  data() {
    return {
      result: "",
      user: "空",
      messagenumber: "",
      WorkReportList: []
    };
  },
  methods: {
    share: function () {
      alert(1);
    },
  },
  created() {
    //获取用户信息
    this.user = this.$store.state.userinfo.username;
    this.messagenumber = this.$store.state.useruncheckmessagenumber;

    //获取用户尚未处理的消息信息，目前只针对是否有未检查的工作计划

  }
};
</script>